import React from "react";
import Select, { components } from "react-select";
import Chip from "@material-ui/core/Chip";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import Cancel from "@material-ui/icons/Cancel";

const customStyles = {
  container: (base, state) => ({
    ...base,
    width: "100%"
  }),
  control: (base, state) => ({
    ...base,
    border: 0,
    background: "transparent",
    boxShadow: "none",
    minHeight: 32
  }),
  menu: (base, state) => ({
    ...base,
    zIndex: 4000
  }),
  multiValue: (base, state) => ({
    ...base,
    alignItems: "center",
    backgroundColor: ""
  }),
  multiValueRemove: (base, state) => ({
    color: "rgba(0, 0, 0, 0.26)",
    cursor: "pointer",
    "&:hover": {
      color: "rgba(0, 0, 0, 0.4)"
    }
  }),
  placeholder: (base, state) => ({
    ...base,
    color: "rgba(0, 0, 0, 0.54)",
    padding: 0,
    fontSize: "1rem",
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    lineHeight: 1,
    margin: 0
  }),
  valueContainer: (base, state) => ({
    ...base,
    padding: 0,
    outline: 0
  })
};

// Needed to discard props passed by react-select
function DropdownIndicator(props) {
  return <ArrowDropDown style={{ color: "rgba(0, 0, 0, 0.54)" }} />;
}

const MultiValueLabel = props => {
  return <Chip label={props.children} />;
};

const MultiValueRemove = props => {
  return (
    <components.MultiValueRemove {...props}>
      <Cancel />
    </components.MultiValueRemove>
  );
};

const Option = props => {
  const { data, isFocused, innerProps } = props;
  return (
    <MenuItem
      key={innerProps.id}
      value={data.value}
      selected={isFocused}
      onClick={() => innerProps.onClick()}
    >
      {data.label}
    </MenuItem>
  );
};

const SelectWrapped = props => {
  const { onChange, onFocus, onBlur, options, values, inputRef } = props;
  return (
    <Select
      ref={ref => {
        inputRef(ref ? ref.select : null);
      }}
      value={values}
      onFocus={onFocus}
      onBlur={onBlur}
      onChange={onChange}
      isMulti={true}
      isSearchable={true}
      defaultValue={options[0]}
      styles={customStyles}
      placeholder=""
      components={{
        DropdownIndicator,
        IndicatorSeparator: null,
        MultiValueLabel,
        MultiValueRemove,
        Option
      }}
      options={options}
      classNamePrefix="fooo"
      onKeyDown={e => e.stopPropagation()}
    />
  );
};

class MultiSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = { shrinkLabel: this.props.values.length !== 0 };
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.values.length === 0 && this.props.values.length > 0) {
      this.setState({ shrinkLabel: true });
    }
  }

  onFocus() {
    this.setState({ shrinkLabel: true });
  }

  onBlur() {
    if (this.props.values.length === 0) {
      this.setState({ shrinkLabel: false });
    }
  }

  render() {
    return (
      <React.Fragment>
        <InputLabel shrink={this.state.shrinkLabel}>
          {this.props.label ? this.props.label : "Value"}
        </InputLabel>
        <Input
          fullWidth
          inputComponent={SelectWrapped}
          inputProps={{
            onChange: this.props.onChange,
            onFocus: this.onFocus,
            onBlur: this.onBlur,
            options: this.props.options,
            values: this.props.values
          }}
        />
      </React.Fragment>
    );
  }
}

export default MultiSelect;



// WEBPACK FOOTER //
// ./src/components/MultiSelect.js